import { Box, Paper } from '@mui/material';
import styled from 'styled-components';

export const StyledContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 10%;
  width: 100%;
  margin-bottom: 15px;
`;

export const StyledItem = styled(Paper)`
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
`;

export const StyledBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 24px 24px 24px rgba(0, 0, 0, 0.2);
  padding: 16px;
  border-radius: 8px;
`;
